<template>
    <b-card class="border">
        <template #header>
            <h2>{{ $t("settings.channels.Authentication") }}</h2>
        </template>

        <p>
            {{ $t("settings.channels.eazy.explainer") }}
        </p>

        <b-form-group
            id="fieldset-eazy-key"
            label-cols-sm="4"
            label-cols-lg="3"
            label-align="right"
            content-cols-sm
            content-cols-lg="7"
            label-for="eazy-key"
            :label="$t('settings.channels.eazy.key.label')"
            :description="$t('settings.channels.eazy.key.description')"
        >
            <b-input-group>
                <b-form-input v-model="auth.apiKey" name="eazy-key"></b-form-input>
                <b-button name="eazy-key-submit" variant="primary" @click="checkKey()">
                    <b-spinner v-if="verifying" small></b-spinner>
                    {{ $t("settings.channels.eazy.key.verify") }}
                </b-button>
            </b-input-group>
        </b-form-group>
        <b-form-group
            id="fieldset-eazy-channel"
            label-cols-sm="4"
            label-cols-lg="3"
            label-align="right"
            content-cols-sm
            content-cols-lg="7"
            label-for="eazy-key"
            :label="$t('settings.channels.eazy.channel.label')"
            :description="$t('settings.channels.eazy.channel.description')"
        >
            <b-input-group>
                <b-form-select v-model="channelData.identity" :options="options"></b-form-select>
                <b-button name="eazy-key-link" variant="primary" @click="linkChannel">
                    <b-spinner v-if="selecting" small></b-spinner>
                    {{ $t("settings.channels.eazy.channel.select") }}
                </b-button>
            </b-input-group>
        </b-form-group>
    </b-card>
</template>
<script>
import axios from "@/libs/axios";
import { BCard, BInputGroup, BFormInput, BButton, BFormGroup, BFormSelect, BSpinner } from "bootstrap-vue";
import useEazy from "../../useEazy";

export default {
    components: {
        BCard,
        BInputGroup,
        BFormInput,
        BButton,
        BFormGroup,
        BFormSelect,
        BSpinner,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { verifyKey, options } = useEazy();

        if (!props.channelData.auth) {
            props.channelData.auth = "{}";
        }
        const auth = JSON.parse(props.channelData.auth);
        const selecting = false;
        const verifying = false;

        if (auth.apiKey) {
            verifyKey(auth.apiKey, props.channelData.id);
        }

        return {
            auth,
            options,
            verifyKey,
            selecting,
            verifying,
        };
    },
    methods: {
        async linkChannel() {
            this.selecting = true;
            if (this.channelData.identity === "disconnected") {
                return this.disconnect();
            }

            try {
                await axios.patch(`channels/${this.channelData.id}`, {
                    identity: this.channelData.identity,
                    settings: [],
                });

                await axios.post(`channels/${this.channelData.id}/connect`);

                this.$toast.success(this.$t("settings.channels.eazy.connecting.success"));
            } catch {
                this.$toast.error(this.$t("settings.channels.eazy.connecting.failure"));
            }

            this.selecting = false;
        },
        disconnect() {
            axios
                .post(`channels/${this.channelData.id}/disconnect`)
                .then(() => {
                    this.$toast.success(this.$t("settings.channels.eazy.disconnecting.success"));
                })
                .catch(() => {
                    this.$toast.error(this.$t("settings.channels.eazy.disconnecting.failure"));
                })
                .finally(() => (this.selecting = false));
        },
        checkKey() {
            this.verifying = true;
            this.verifyKey(this.auth.apiKey, this.channelData.id)
                .then(() => {
                    this.$toast.success(this.$t("settings.channels.eazy.verifying.success"));
                })
                .catch(() => {
                    this.$toast.error(this.$t("settings.channels.eazy.verifying.failure"));
                })
                .finally(() => (this.verifying = false));
        },
    },
};
</script>
